import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="gp-page py-6">
      <div className="gp-container max-w-3xl">
        <Link to="/" className="gp-back-link mb-4">
          <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
          Back to Home
        </Link>

        <div className="gp-page-header">
          <div className="flex items-center gap-2 mb-1">
            <span className="gp-icon-tile">
              <FontAwesomeIcon icon={faShieldAlt} aria-hidden="true" />
            </span>
            <h1 className="gp-page-title">Privacy Policy</h1>
          </div>
          <p className="gp-page-subtitle text-xs">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="gp-card space-y-5">
          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              1. Information We Collect
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted mb-1.5">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc list-inside text-sm gp-text-muted space-y-1 ml-1">
              <li>Account information (name, email address, password)</li>
              <li>Payment information (processed securely through third-party providers)</li>
              <li>Usage data and progress tracking</li>
              <li>Communication preferences</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              2. How We Use Your Information
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted mb-1.5">We use the information we collect to:</p>
            <ul className="list-disc list-inside text-sm gp-text-muted space-y-1 ml-1">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              3. Information Sharing
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              We do not sell, trade, or rent your personal information to third parties. We may share your information
              only with service providers who assist us in operating our platform, conducting our business, or serving
              our users.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              4. Data Security
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              We implement appropriate security measures to protect your personal information. However, no method of
              transmission over the Internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              5. Your Rights
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted mb-1.5">You have the right to:</p>
            <ul className="list-disc list-inside text-sm gp-text-muted space-y-1 ml-1">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of certain communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              6. Cookies
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              We use cookies to enhance your experience, analyze site usage, and assist in our marketing efforts. You
              can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              7. Contact Us
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@globalpreps.com" className="gp-link">
                privacy@globalpreps.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
